import React from "react";
import { usePromiseTracker } from "react-promise-tracker";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

const Loading = () => {
    const { promiseInProgress } = usePromiseTracker();
    return (
        promiseInProgress
        ? (
            <Backdrop sx={{ zIndex: 1999, color: "#fff"}} open={true}>
                <CircularProgress color="inherit" />
            </Backdrop>
        )
        : null
    );
}

export default Loading;
